export class DINotFoundDependencyError extends Error {

  constructor() {
    super('Not fount DI dependency');

    Object.setPrototypeOf(this, new.target.prototype);
  }

}
